import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { SEO } from '@/components/SEO';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Breadcrumbs from '@/components/ui/Breadcrumbs';
import { Button } from '@/components/ui/button';
import { SERVICE_AREAS } from '@/data/serviceAreas';

const AreasPage = () => (
  <>
    <SEO
      title="Service Areas | Pressure Washing Across Ventura County | Ventura Power Washing"
      description="Ventura Power Washing serves Ventura, Oxnard, Camarillo, Thousand Oaks, Newbury Park, Westlake Village, Simi Valley, Moorpark, Ojai, Santa Paula, Fillmore, and Port Hueneme. Call (805) 464-7166."
      path="/areas"
    />
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Service Areas', href: '/areas' }]} />
      <main className="flex-1">
        <header className="bg-gradient-to-br from-ventura-blue to-ventura-darkBlue text-white py-16">
          <div className="container mx-auto px-4 md:px-6 max-w-4xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Service Areas</h1>
            <p className="text-lg text-white/95">
              Ventura Power Washing provides pressure washing, soft washing, window, gutter, solar panel, carpet, and dumpster pad cleaning across Ventura County and nearby communities. Choose your city to see local details.
            </p>
          </div>
        </header>

        <div className="container mx-auto px-4 md:px-6 max-w-4xl py-12 space-y-10">
          <ul className="grid gap-4 sm:grid-cols-2">
            {SERVICE_AREAS.map((area) => (
              <li key={area.path} className="rounded-lg border border-gray-200 p-5">
                <h2 className="text-xl font-semibold">
                  <Link to={area.path} className="text-ventura-blue hover:underline">
                    Pressure Washing in {area.name}
                  </Link>
                </h2>
                {area.neighborhoods.length > 0 && (
                  <p className="text-gray-600 mt-1">Including {area.neighborhoods.join(', ')}</p>
                )}
              </li>
            ))}
          </ul>

          <section aria-labelledby="beyond">
            <h2 id="beyond" className="text-2xl font-bold text-gray-900 mb-3">Beyond Ventura County</h2>
            <p className="text-gray-700">
              We also take on select projects across Los Angeles, Orange, San Diego, and Santa Barbara counties. Call {' '}
              <a href="tel:+18054647166" className="text-ventura-blue hover:underline">(805) 464-7166</a> to confirm availability. We do not serve Northern California or the High Desert.
            </p>
          </section>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button asChild size="lg" className="bg-ventura-blue hover:bg-ventura-darkBlue">
              <Link to="/free-estimate">Get a Free Estimate</Link>
            </Button>
            <Button asChild size="lg" variant="outline">
              <a href="tel:+18054647166"><Phone className="mr-2 h-4 w-4" />(805) 464-7166</a>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  </>
);

export default AreasPage;
